export const DEFAULT_SWAP_SLIPPAGE_TOLERANCE_PCT = 0.1;
